<div class="unauthorized-container">
  <div class="icon-container">
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>
    </svg>
  </div>
  
  <h2>Session Expired</h2>
  
  <p class="main-message">
    Your login session has expired or could not be renewed automatically.
  </p>
  
  <div class="details">
    <p *ngIf="providerName !== 'Imperia or Suite Edge'">
      You were connected via <strong>{{ providerName }}</strong>.
    </p>
    
    <p class="reason">
      <strong>Possible reasons:</strong>
    </p>
    <ul>
      <li>Too much time without activity</li>
      <li>The access token has expired</li>
      <li>Connection was lost during renewal</li>
    </ul>
  </div>
  
  <div class="actions">
    <button *ngIf="platformUrl" class="btn-primary" (click)="returnToPlatform()">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="19" y1="12" x2="5" y2="12"></line>
        <polyline points="12 19 5 12 12 5"></polyline>
      </svg>
      Return to {{ providerName }}
    </button>
    
    <button class="btn-secondary" (click)="tryReconnect()">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="23 4 23 10 17 10"></polyline>
        <polyline points="1 20 1 14 7 14"></polyline>
        <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
      </svg>
      Try to Reconnect
    </button>
  </div>
  
</div>
